import { render, staticRenderFns } from "./CompletedRequests.vue?vue&type=template&id=353c1b81&"
import script from "./CompletedRequests.vue?vue&type=script&lang=js&"
export * from "./CompletedRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports